/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-18 18:21:04
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-14 14:50:55
 * @FilePath: \ioc_base\src\modules\log\options\logTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic, Dates } from "$utils";
const tableOption = function (that) {
  return {
    maxHeight: "100%",
    page: true,
    editBtn: false,
    delBtn: false,
    header: false,
    menu: true,
    view: "详情",
    stripe: true,
    emptyText: that.$t("taskCenter.label.noData"),
    menuAlign: "center",
    menuWidth: 70,
    viewFormSlot: true,
    labelSuffix: ' ：',
    dialogWidth: "700",
    index: true,
    indexLabel: "序号", //this.$t('taskCenter.label.count'),'序号1',
    column: [
      {
        label: "操作账号",
        prop: "operate",
        search: true,
        clearable: true
      },
      {
        label: "姓名",
        prop: "operatorName",
        search: true,
        clearable: true
      },

      {
        label: "操作模块",
        prop: "operateModule",
        search: true,
        searchSlot: true
      },
      {
        label: "操作功能",
        prop: "operateFunction",
        search: true,
        searchSlot: true
      },
      {
        label: "操作类型",
        prop: "operateType",
        search: true,
        searchSlot: true
      },
      {
        label: "操作结果",
        prop: "operateResult"
      },
      {
        label: "操作时间",
        prop: "operateTime",
        search: true,
        type: "daterange"
      },
      {
        label: "操作IP",
        prop: "ip",
        clearable: true,
        span: 24,
        search: true,
      },
      {
        label: "操作内容",
        prop: "operateDesc",
        span: 24,
        hide: true
      }
    ]
  };
};

export default tableOption;
